var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"md":"12"}},[_c('section',{staticClass:"informations"},[_c('knowbefore',{attrs:{"property":_vm.solution.property.details}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }